import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Centralised sign-out: clears the session via AuthContext, then sends the
 * user back to the auth page so they can't reuse browser back to land on a
 * protected route while a stale render is still on screen.
 */
export function useLogout(redirectTo: string = "/auth/login") {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return useCallback(async () => {
    await logout();
    navigate(redirectTo, { replace: true });
  }, [logout, navigate, redirectTo]);
}
